<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class PackagePageMixin extends Vue {
        async loadRuntimeData() {
            const {arrivalCityId, departureCityId} = this.searchRequest
            if (
                packagesRuntimeStore.arrivalPoint.id !== arrivalCityId ||
                packagesRuntimeStore.departurePoint.id !== departureCityId
            ) {
                await packagesRuntimeStore.loadPoints({arrivalCityId, departureCityId})
            }
        }
    }

    export default PackagePageMixin
</script>
